/* eslint-disable jsx-a11y/label-has-associated-control */

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { useStyles } from './useStyles';

export const TextArea = ({
  placeholder, text, onChangeHandler, className, maxLength
}) => {
  const classes = useStyles();

  return (
    <Box className={classNames(classes.textAreaContainer, className)}>
      <textarea
        required
        maxLength={maxLength}
        className={classes.textArea}
        value={text}
        onChange={onChangeHandler}
      />
      <label className={classes.label}>{placeholder}</label>
      <label className={classes.counter}>
        {text.length}
        {' '}
        /
        {' '}
        {maxLength}
      </label>
    </Box>
  );
};

TextArea.propTypes = {
  placeholder: PropTypes.string,
  text: PropTypes.string,
  onChangeHandler: PropTypes.func,
  maxLength: PropTypes.number
};

TextArea.defaultProps = {
  placeholder: '',
  text: '',
  onChangeHandler: () => {},
  maxLength: 140
};
